"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-sant-angelo": {
    "c81fe44d": [{
      "hkey": "3c9b310c",
      "slug": "monte-sant-angelo",
      "name": "Monte Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "macchia-marina-di-monte-santangelo": [{
      "hkey": "3c9b310c",
      "slug": "monte-sant-angelo",
      "name": "Monte Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90c00e74": [{
      "hkey": "3c9b310c",
      "slug": "monte-sant-angelo",
      "name": "Monte Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "ruggiano": [{
      "hkey": "3c9b310c",
      "slug": "monte-sant-angelo",
      "name": "Monte Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;